import axios from 'axios'
import store from '@/store'
import Vue from 'vue'

const service = axios.create({
  baseURL: process.env.BASE_API,
  withCredentials:true,
  timeout: 30000
})
service.interceptors.request.use(config => {
  config.headers['Token'] = store.getters.token
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if(!res.result){
      Vue.$vux.alert.show({
        title: '操作失败',
        content:  res.msg,
      })
    }
    // if (res.code === 40004 && !res.result) {
    //   logout().then(() => {
    //     location.reload()
    //   })
    //   return Promise.reject('error')
    // } 
    return response
  },
  error => {
    // console.log('err' + error) // for debug
    Vue.$vux.alert.show({
      title: '操作失败',
      content:  error.message,
    })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/assets/js/utils/request.js